import { Breadcrumb, Input, Layout, Select } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { apiGet, urls } from 'api'
import { IcEye, IcSearch } from 'assets/icons'
import { CardContainer, Table } from 'components'
import moment from 'moment'
import { useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { logout } from 'store/actions'
import { showErrorMessage } from 'utils'

const initialTableState = {
  totalRows: 0,
  offset: 0,
  limit: 10,
  keywords: '',
  listData: [],
  owner_name: '',
  status: ''
}

const TotalUnitCabang = () => {
  const { push, goBack } = useHistory()
  const { id, cabang } = useParams()
  const token = useSelector((state) => state.auth.token)
  const [tableState, setTableState] = useState(initialTableState)
  const dispatch = useDispatch()
  const onLogout = () => {
    dispatch(logout())
  }

  const [dropdownPemilik, setdropdownPemilik] = useState([])
  const [dropdownStatus, setdropdownStatus] = useState([])

  const columnStyle = 'font-medium text-gray-700'

  const columns = [
    {
      name: 'Tanggal',
      selector: (row) => (row?.created_at ? moment(row?.created_at).format('DD/MM/YYYY') : '-'),
      cell: (row) => (
        <span className={columnStyle}>
          {row?.created_at ? moment(row?.created_at).format('DD/MM/YYYY') : '-'}
        </span>
      ),
      grow: 1
    },
    {
      name: 'Model Mobil',
      selector: (row) => row?.unit_name,
      cell: (row) => (
        <div className="flex flex-col space-y-2 py-3">
          <span className={columnStyle}>{row?.unit_name}</span>
          <span className="font-normal text-gray-500 tracking-tight">{row?.police_number}</span>
        </div>
      ),
      grow: 3
    },
    {
      name: 'Pemilik',
      selector: (row) => row?.unit_owner,
      cell: (row) => <span className={columnStyle}>{row?.unit_owner}</span>,
      grow: 2
    },
    {
      name: 'Status',
      selector: (row) => (
        <div
          className={`flex justify-center items-center rounded-full text-sm-medium px-2 py-0.5 ${
            row?.unit_status === 'Inspeksi' || row?.unit_status === 'Sedang diinspeksi'
              ? 'bg-success-100 text-success-700'
              : row?.unit_status === 'Dijual'
              ? 'bg-blue-100 text-blue-700'
              : row?.unit_status === 'Servis' || row?.unit_status === 'Sedang diservis'
              ? 'bg-warning-100 text-warning-700'
              : 'bg-gray-100 text-gray-700'
          }`}>
          <span>{row?.unit_status}</span>
        </div>
      ),
      grow: 2
    },
    {
      name: 'Action',
      button: true,
      ignoreRowClick: true,
      sortable: false,
      right: true,
      center: true,
      cell: (row) => (
        <div
          onClick={() =>
            push(
              `/workshop-management/${cabang}/total-unit/detail-unit/${row.id}/${row?.unit_name}`
            )
          }
          className="flex items-center gap-2 justify-center self-center px-2 py-2 my-2 border border-solid border-gray-300 rounded-lg hover:cursor-pointer">
          <IcEye className="text-gray-700" />
          <span className="text-sm-medium text-gray-700">Lihat</span>
        </div>
      ),
      grow: 1
    }
  ]

  // Get Api
  // Get unit list
  const { isLoading, isFetching } = useQuery({
    queryKey: [
      'unit-list',
      tableState.offset,
      tableState.limit,
      tableState.sort_by,
      tableState.sort_order,
      tableState.keywords,
      tableState.owner_name,
      tableState.status
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await apiGet({
        token,
        url: `${urls.analytic.prefixMaster}/${urls.analytic.transactionBranch.unitTotalList}/${id}?keywords=${tableState.keywords}&limit=${tableState?.limit}&offset=${tableState?.offset}&owner_name=${tableState?.owner_name}&status=${tableState?.status}`,
        onLogout
      })
      if (res?.resStatus !== 200 && res?.resStatus !== 401) {
        showErrorMessage({ content: res?.resData?.errors?.[0]?.message })
      }
      return res
    },
    onSuccess: (res) => {
      setTableState((prev) => ({
        ...prev,
        listData: res?.resData?.data ?? [],
        totalRows: res?.resData?.meta?.total
      }))
    }
  })

  // Get list owner
  useQuery({
    queryKey: ['owner-list'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await apiGet({
        token,
        url: `${urls.analytic.prefixMaster}/${urls.analytic.transactionBranch.unitTotalOwner}`,
        onLogout
      })
      if (res?.resStatus !== 200 && res?.resStatus !== 401) {
        showErrorMessage({ content: res?.resData?.errors?.[0]?.message })
      }
      return res
    },
    onSuccess: (res) => {
      setdropdownPemilik(res?.resData?.data ?? [])
    }
  })

  // Get list statuses
  useQuery({
    queryKey: ['statuses-list'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await apiGet({
        token,
        url: `${urls.analytic.prefixMaster}/${urls.analytic.transactionBranch.unitTotalStatus}`,
        onLogout
      })
      if (res?.resStatus !== 200 && res?.resStatus !== 401) {
        showErrorMessage({ content: res?.resData?.errors?.[0]?.message })
      }
      return res
    },
    onSuccess: (res) => {
      setdropdownStatus(res?.resData?.data ?? [])
    }
  })

  const handlePerRowsChange = (newPerPage) => {
    setTableState((prev) => ({
      ...prev,
      limit: newPerPage,
      offset: 0
    }))
  }

  const onChangePage = (page) => {
    setTableState((prev) => ({
      ...prev,
      offset: page
    }))
  }

  return (
    <Layout style={{ padding: 32, background: '#F5F5F5', width: '100%' }}>
      <Breadcrumb style={{ margin: 8 }}>
        <Breadcrumb.Item className="font-inter font-semibold text-gray-700">
          Workshop Management
        </Breadcrumb.Item>
        <Breadcrumb.Item
          className="font-inter font-medium text-gray-500 cursor-pointer"
          onClick={() => goBack()}>
          {cabang ?? ''}
        </Breadcrumb.Item>
        <Breadcrumb.Item className="font-inter font-medium text-gray-500">
          Total Unit
        </Breadcrumb.Item>
      </Breadcrumb>
      <Content style={{ margin: 8 }}>
        <CardContainer minHeight="65%" className={'grid grid-cols-1 gap-5'}>
          <p className="display-xs-semibold text-gray-900 m-0">Daftar Unit</p>
          <div className="flex flex-row w-full items-center justify-between">
            <div className="flex flex-row w-full items-center space-x-3">
              <Select
                className="custom-table-limit [&.custom-table-limit>.ant-select-selector]:!h-auto [&.custom-table-limit>.ant-select-selector]:!py-1 mr-3"
                style={{ minWidth: '150px' }}
                value={tableState?.owner_name}
                onChange={(e) => setTableState((prev) => ({ ...prev, owner_name: e, offset: 0 }))}>
                <Select.Option value={''}>Semua Pemilik</Select.Option>
                {dropdownPemilik?.map((pemilik, idx) => (
                  <Select.Option key={idx} value={pemilik}>
                    {pemilik}
                  </Select.Option>
                ))}
              </Select>
              <Select
                className="custom-table-limit [&.custom-table-limit>.ant-select-selector]:!h-auto [&.custom-table-limit>.ant-select-selector]:!py-1 mr-3"
                style={{ minWidth: '150px' }}
                value={tableState?.status}
                onChange={(e) => setTableState((prev) => ({ ...prev, status: e, offset: 0 }))}>
                <Select.Option value={''}>Semua Status</Select.Option>
                {dropdownStatus?.map((status, idx) => (
                  <Select.Option key={idx} value={status}>
                    {status}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <Input
              className="w-1/4 rounded-md py-2"
              placeholder="Pencarian"
              prefix={<IcSearch className="text-gray-400" />}
              value={tableState?.keywords}
              onChange={(e) =>
                setTableState((prev) => ({ ...prev, keywords: e?.target?.value, offset: 0 }))
              }
            />
          </div>
          <div className="flex flex-col w-full space-y-5">
            <div className="flex flex-col space-y-5">
              <Table
                columns={columns}
                data={tableState?.listData}
                pending={isLoading ?? isFetching}
                totalRows={tableState?.totalRows}
                handlePerRowsChange={handlePerRowsChange}
                pageSize={tableState?.limit}
                page={tableState?.offset}
                onChangePrevPage={() => {
                  if (tableState?.offset > 0) {
                    onChangePage(tableState?.offset - tableState?.limit)
                  }
                }}
                onChangeNextPage={() => {
                  if (tableState?.totalRows > tableState?.limit + tableState?.offset) {
                    onChangePage(tableState?.offset + tableState?.limit)
                  }
                }}
              />
            </div>
          </div>
        </CardContainer>
      </Content>
    </Layout>
  )
}

export default TotalUnitCabang
